import PropTypes from 'prop-types';
import CmsModules from 'libs/storyblok/content/Modules';
import { styled, useStyletron } from '@activebrands/core-web/libs/styletron';

const FooterWrapper = styled('footer', {});

const FooterCore = ({ $style = {}, ariaLabel, footerContent = {}, children = null, id = 'footer' }) => {
    const [css] = useStyletron();

    return (
        <FooterWrapper $style={$style} data-selector="global.footer" id={id} aria-label={ariaLabel} tabIndex={-1}>
            <div className={css({ margin: '0 auto' })}>
                {footerContent && <CmsModules isFooter modules={footerContent} />}
                {children}
            </div>
        </FooterWrapper>
    );
};

FooterCore.propTypes = {
    $style: PropTypes.object,
    ariaLabel: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)].isRequired),
    footerContent: PropTypes.arrayOf(PropTypes.object),
    id: PropTypes.string,
};

export default FooterCore;
